import { poppins500, poppins600 } from 'theme/common.style';

export const title = {
  fontFamily: 'Poppins !important',
  fontStyle: 'normal !important',
  fontWeight: '600 !important',
  fontSize: '32px !important',
  color: '#1E1E1E',
};
export const header = {
  display: 'flex',
  textAlign: 'center',
  margin: '10px 0',
};

export const tabIcon = {
  background: '#FBFBFB',
  fontSize: '16px',
  fontWeight: 400,
  display: 'flex',
  fontStyle: 'Regular',
  justifyContent: 'center',
};
export const tabDesign = {
  display: 'flex',
  alignItems: 'center',
};

export const headerProp = {
  ...poppins600,
  fontSize: '25px',
  color: '#687999',
};
export const textboxmargin = {
  marginTop: '5px',
  '.MuiFormHelperText-contained': {
    margin: '0',
  },
  '& .MuiOutlinedInput-root': {
    '& > fieldset': { borderColor: 'rgba(0, 85, 255, 0.64)' },
  },
  '& .MuiOutlinedInput-root:hover': {
    '& > fieldset': {
      // borderColor: "rgba(0, 85, 255, 0.64)",
      color: '#666666',
      fontSize: '16px',
      fontFamily: 'Poppins',
      fontWeight: '300',
    },
  },
  '& .MuiInputBase-root': {
    color: '#666666',
    fontSize: '16px',
    fontFamily: 'Poppins',
    fontWeight: '300',
    height: '48px',
  },
  '& .MuiTextField-root': {
    height: '48px',
  },
  '& input[type=number]': {
    '-moz-appearance': 'textfield',
  },
  '& input[type=number]::-webkit-outer-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
  '& input[type=number]::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
};
export const textboxmargin_description = {
  marginTop: '5px',
  '.MuiFormHelperText-contained': {
    margin: '0',
  },
  '& .MuiOutlinedInput-root': {
    '& > fieldset': { borderColor: 'rgba(0, 85, 255, 0.64)' },
  },
  '& .MuiOutlinedInput-root:hover': {
    '& > fieldset': {
      borderColor: 'rgba(0, 85, 255, 0.64)',
      color: '#666666',
      fontSize: '16px',
      fontFamily: 'Poppins',
      fontWeight: '300',
    },
  },
  '& .MuiInputBase-root': {
    color: '#666666',
    fontSize: '16px',
    fontFamily: 'Poppins',
    fontWeight: '300',
  },
  '& .MuiTextField-root': {
    height: '48px',
  },
};
export const select_dropdown = {
  marginTop: '4.5px',
  fontFamily: 'Poppins',
  fontSize: '16px',
  fontWeight: '300',
  color: '#000000',
  '& .MuiMenuItem-root': {
    fontFamily: 'Poppins !important',
    fontWeight: '300',
  },

  '& .MuiInput-input': {
    fontFamily: 'Poppins !important',
    fontWeight: '300',
  },
  '& .MuiSvgIcon-root ': {
    fill: '#000000 !important',
  },

  '.MuiOutlinedInput-notchedOutline': {
    border: '1px solid rgba(17, 35, 71, 0.1)',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: '1px solid rgba(17, 35, 71, 0.1)',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: '1px solid rgba(17, 35, 71, 0.1)',
  },
};
export const select_dropdown_retrex = {
  marginTop: '4.5px',
  fontFamily: 'Poppins',
  fontSize: '16px',
  fontWeight: '300',
  borderRadius: '5px',
  color: '#000000',
  background: 'white',
  border: '1px #112347',
  '& .MuiMenuItem-root': {
    fontFamily: 'Poppins !important',
    fontWeight: '300',
  },
  '& .MuiInput-input': {
    fontFamily: 'Poppins !important',
    fontWeight: '300',
  },
  '& .MuiSvgIcon-root ': {
    fill: '#000000 !important',
  },
  '.MuiOutlinedInput-notchedOutline': {
    border: '1px solid rgba(17, 35, 71, 0.1)',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: '1px solid rgba(17, 35, 71, 0.1)',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: '1px solid rgba(17, 35, 71, 0.1)',
  },
};
export const pick_date = {
  '& .MuiFormLabel-root': {
    fontFamily: 'Poppins !important',
    fontSize: '16px !important',
    fontWeight: '300',
  },
  '& .MuiButtonBase-root .MuiPickersDay-root .MuiPickersDay-dayWithMargin': {
    fontFamily: 'Poppins !important',
  },
  '& .MuiPickersCalendarHeader-label': {
    fontFamily: 'Poppins !important',
  },
  '& .MuiInputBase-input': {
    fontFamily: 'Poppins !important',
    fontSize: '16px !important',
    fontWeight: '300',
  },
  '& .MuiInputLabel-root': {
    fontFamily: 'Poppins !important',
    fontSize: '16px !important',
    fontWeight: '300',
  },
  '& .MuiSvgIcon-root ': {
    fill: '#212529 !important',
  },
  '.MuiOutlinedInput-notchedOutline': {
    border: '1px solid rgba(17, 35, 71, 0.1)',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: '1px solid rgba(17, 35, 71, 0.1)',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: '1px solid rgba(17, 35, 71, 0.1)',
  },
};
export const checkbox_style = {
  fontFamily: 'Poppins',
  fontSize: '14px',
  fontWeight: '400',
  color: '#737497',
};
export const textboxmargin_company = {
  marginTop: '10px',
  '.MuiFormHelperText-contained': {
    margin: '0',
  },
  '& .MuiOutlinedInput-root': {
    '& > fieldset': { borderColor: 'rgba(0, 85, 255, 0.64)' },
  },
  '& .MuiOutlinedInput-root:hover': {
    '& > fieldset': {
      borderColor: 'rgba(0, 85, 255, 0.64)',
      color: '#666666',
      fontSize: '16px',
      fontFamily: 'Poppins',
      fontWeight: '300',
    },
  },
  '& .MuiInputBase-root': {
    color: '#666666',
    fontSize: '16px',
    fontFamily: 'Poppins',
    fontWeight: '300',
  },
};
export const textboxmargin1 = {
  marginTop: '5px',
  '.MuiFormHelperText-contained': {
    margin: '0',
  },
  '& .MuiOutlinedInput-root': {
    '& > fieldset': { borderColor: 'rgba(0, 85, 255, 0.64)' },
  },
  '& .MuiOutlinedInput-root:hover': {
    '& > fieldset': {
      borderColor: 'rgba(0, 85, 255, 0.64)',
      color: 'rgba(32, 14, 50, 1)',
      fontSize: '16px',
      fontFamily: 'Poppins',
      fontWeight: '300',
    },
  },
  '& .MuiInputBase-root': {
    color: '#666666',
    fontSize: '16px',
    fontFamily: 'Poppins',
    fontWeight: '300',
  },
};
export const typography_textfield = {
  fontStyle: 'Regular',
  fontFamily: 'Poppins',
  fontSize: { xs: '14px', md: '20px' },
  fontWeight: '400',
  color: '#000000 !important',
  display: 'flex',
  alignItems: 'center',
};
export const typography_textfield_16 = {
  fontStyle: 'Regular',
  fontFamily: 'Poppins',
  fontSize: '16px',
  fontWeight: '400',
  color: '#000000',
};
export const render_details = {
  fontStyle: 'Regular',
  fontFamily: 'Poppins',
  fontWeight: '300',
  fontSize: '16px',
  color: '#200E32',
};
export const typography_textfield_legalrep = {
  fontStyle: 'Regular',
  fontFamily: 'Poppins',
  fontWeight: '400',
  lineHeight: '24px',
  fontSize: '16px',
  color: '#200E32',
};
export const upcoming_instructions = {
  fontStyle: 'Regular',
  fontFamily: 'Poppins',
  fontSize: '20px',
  fontWeight: '300',
  color: 'rgba(104, 121, 153, 1)',
};

export const campaignDays = {
  marginTop: '5px',
  width: '150%',
  '.MuiFormHelperText-contained': {
    margin: '0',
  },
};

export const textboxarea = {
  marginTop: '3px',
};

export const stackBox = {
  width: '208px',
  height: '122px',
  backgroundColor: 'rgba(108, 42, 210, 0.1)',
  border: '2px dashed rgba(108, 42, 210, 1)',
  textAlign: 'center',
};

export const icon = {
  height: '16px',
  width: '16px',
  marginTop: '-2px',
  marginRight: '10px',
};
export const icon_land = {
  height: '16px',
  width: '16px',
  marginTop: '1px',
  marginRight: '9px',
};
export const image = {
  marginTop: '9px',
};
export const closeImageIcon = {
  position: 'relative',
  color: 'red',
  marginLeft: '115px',
  cursor: 'pointer',
  backgroundColor: 'white',
  borderRadius: '15px',
};
export const cancelBtn = {
  ...poppins500,
  fontSize: '16px',
  color: 'black',
  width: '210px',
  height: '48px',
  background: '#FFFFFF',
  border: '1px solid #DFDFDF',
  borderRadius: '8px',
  textTransform: 'inherit',
  padding: '12px 76px 12px 76px',
  ' &:hover': {
    backgroundColor: '#FFFFFF !important',
    color: '#6C2AD2',
    border: '1px solid #6C2AD2 !important ',
  },
};
export const addAdditionalOwner = {
  ...poppins500,
  fontSize: '16px',
  color: 'black',
  width: '351px',
  height: '48px',
  background: '#FFFFFF',
  border: '1px solid #DFDFDF',
  borderRadius: '8px',
  textTransform: 'inherit',
  padding: '12px 73px 12px 73px',
  ' &:hover': {
    backgroundColor: '#FFFFFF !important',
    color: '#6C2AD2',
    border: '1px solid #6C2AD2 !important ',
  },
};
export const nextBtn = {
  backgroundColor: '#965CF0 !important',
  ...poppins500,
  color: '#FFFFFF !important',
  fontSize: '16px',
  borderRadius: '8px',
  width: '210px',
  height: '48px',
  textTransform: 'inherit',
  padding: '12px 87px 12px 87px',
  border: '1px solid #AF05FF !important',
  ' &:hover': {
    backgroundColor: '#965CF0 !important',
    border: '1px solid #AF05FF !important ',
  },
};
